module.exports = __webpack_public_path__ + "static/media/number_line_bg_red.ebb69c48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/number_line_bg_red.svg
// module id = 1405
// module chunks = 0